import React, { useState } from 'react';
import TextField from '../../Form/TextField';
import {
    EuiButton,
    EuiFlexItem,
    EuiFlyout,
    EuiFlyoutBody,
    EuiFlyoutHeader,
    EuiSpacer,
    EuiText,
    EuiTitle,
} from '@elastic/eui';
import FormGroupDescription from '../../formGroupDescription';
import ButtonGroup from '../../Form/ButtonGroup';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { requestForRiderService } from '../../../api/requestThirdPartyRiderService';
import { getOutletDetails } from '../../../api/outlet/getOutletDetails';

const HLDedicatedRider = () => {
    const {
        formState: { errors },
        control,
        watch,
        setValue,
    } = useFormContext();
    const outletId = useSelector((state) => state.outlet.selectedOutletId);
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);
    const outlet = useSelector((state) => state.outlet.selectedOutletDetails);
    const approvalDate = outlet?.third_party_rider_setting?.wefast_request?.approval_date;
    const serviceStatus = outlet?.third_party_rider_setting?.wefast_request?.status;
    const dispatch = useDispatch();
    const startService = () => {
        dispatch(requestForRiderService('hl_Dedicated', 'rider service request for hl_Dedicated')).then(() => {
            dispatch(getOutletDetails(outletId));
        });
    };
    let flyout;

    if (isFlyoutVisible) {
        flyout = (
            <EuiFlyout
                ownFocus
                onClose={() => {
                    setIsFlyoutVisible(!isFlyoutVisible);
                }}
                aria-labelledby={'simpleFlyoutTitle'}
            >
                <EuiFlyoutHeader hasBorder>
                    <EuiTitle size='m'>
                        <h2>HL Dedicated riders</h2>
                    </EuiTitle>
                </EuiFlyoutHeader>
                <EuiFlyoutBody>
                    <ButtonGroup
                        idSelected={watch('is_hlbackend_integration_enabled') ? '1' : '0'}
                        color='primary'
                        control={control}
                        setValue={setValue}
                        name='is_hlbackend_integration_enabled'
                        watch={watch}
                        label={'HL Dedicated integration'}
                    />

                    {/* {watch('is_hlbackend_integration_enabled') ? (
                        <>
                            <TextField
                                errors={errors}
                                label='HL Dedicated auth token'
                                name='hl_storebased_token'
                                placeholder='Enter WeFast auth token'
                                rules={{ required: 'Please Enter HL Dedicated auth token' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='Enter COID'
                                name='is_coid'
                                placeholder='Enter COID auth token'
                                rules={{ required: 'Please Enter COID' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='HL Dedicated Store Code'
                                name='hl_storebased_store_code'
                                placeholder='Enter Store Code'
                                rules={{ required: 'Please Enter Store Code' }}
                                control={control}
                            />
                        </>
                    ) : (
                        ''
                    )} */}
                </EuiFlyoutBody>
            </EuiFlyout>
        );
    }

    return (
        <div style={{ maxWidth: '650px' }}>
            <FormGroupDescription
                title={restaurantDescriptions?.hl_store_based_riders?.display_name}
                description={restaurantDescriptions?.hl_store_based_riders?.description}
            >
                <EuiFlexItem>
                    <EuiButton
                        style={{
                            backgroundColor: serviceStatus === 'approved' && '#228B22',
                            color: serviceStatus === 'approved' && 'white',
                        }}
                        fill
                        onClick={startService}
                        disabled={serviceStatus ? true : false}
                    >
                        {serviceStatus ? serviceStatus : 'START SERVICE'}
                    </EuiButton>
                </EuiFlexItem>
                <EuiSpacer style={{ marginTop: '6px' }}>
                    <EuiText textAlign='center' size='xs'>
                        ------ OR ------
                    </EuiText>
                </EuiSpacer>
                <EuiFlexItem grow={false}>
                    <EuiButton onClick={() => setIsFlyoutVisible(!isFlyoutVisible)}>CONNECT ACCOUNT</EuiButton>
                </EuiFlexItem>
                {flyout}
            </FormGroupDescription>
            {serviceStatus === 'pending' && (
                <EuiText
                    style={{
                        padding: '8px 12px',
                        background: '#BBB',
                        color: 'white',
                        marginBottom: '12px',
                        borderRadius: '4px',
                        // width: '65%',
                    }}
                >
                    <p> Your reqeust has been received and it shall be activated by {approvalDate} </p>
                </EuiText>
            )}
        </div>
    );
};

export default HLDedicatedRider;
